import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { name: 'HOME', path: '/' },
  { name: 'DISTRIBUTION', path: '/distribution' },
  { name: 'SALES', path: '/sales' },
  { name: 'FILMS', path: '/films' },
  { name: 'FAQ', path: '/faq' },
  { name: 'CONTACT', path: '/contact' },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav 
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-md border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            data-testid="logo-link"
            className="flex items-center"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_ac879796-0773-4f69-ab14-fe9fd8353425/artifacts/qkbaujxq_fbc3ed1a37eaae10a26408b21a2770a8c17902308430bb9de82e8b9410528a61.png" 
              alt="LBR Distribution" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase()}`}
                className={`text-sm tracking-widest font-medium transition-all duration-300 hover:text-orange-500 ${
                  location.pathname === link.path ? 'text-orange-500' : 'text-white/70'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <Link
            to="/submit"
            data-testid="submit-film-btn"
            className="hidden lg:block bg-orange-600 hover:bg-orange-500 text-white font-sans font-bold py-3 px-6 uppercase tracking-widest text-sm transition-all duration-300 hover:tracking-[0.15em]"
          >
            SUBMIT FILM
          </Link>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-white p-2"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/5"
          >
            <div className="px-6 py-8 space-y-6">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                  onClick={() => setIsOpen(false)}
                  className={`block text-lg tracking-widest font-medium transition-colors hover:text-orange-500 ${
                    location.pathname === link.path ? 'text-orange-500' : 'text-white/70'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/submit"
                onClick={() => setIsOpen(false)}
                className="block bg-orange-600 hover:bg-orange-500 text-white font-bold py-4 px-6 uppercase tracking-widest text-center text-sm transition-all"
              >
                SUBMIT FILM
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
